import React from "react";
import { useField, ErrorMessage } from "formik";
import "./TextField.scss";
import { TextareaAutosize } from "@material-ui/core";
import PopOverComponent from "../MaterialUIComponents/PopOverComponent";

const TextField = ({ label, className, autosize = false, infoText, ...props }) => {
	const [field, meta] = useField(props);
	return (
		<>
			<span htmlFor={field.name} className="labelForm">
				<PopOverComponent label={label}>
					<span className="info-popover">{infoText}</span>
				</PopOverComponent>
				{autosize ? (
					<TextareaAutosize
						rowsMin={5}
						{...field}
						{...props}
						className={
							meta.touched && meta.error ? "inputError textField" : "textField"
						}
					/>
				) : (
					<input
						{...field}
						{...props}
						className={
							meta.touched && meta.error ? "inputError textField" : "textField"
						}
					/>
				)}
				<ErrorMessage
					name={field.name}
					className="errorMessage"
					component="span"
				/>
			</span>
		</>
	);
};

export default TextField;
